var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_linkedin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Winds-Webapp",
    transform: "translate(-523.000000, -8608.000000)",
    fill: "#ADADB2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(0.000000, 8145.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(252.000000, 463.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.428571,0 L274.571429,0 C272.6,0 271,1.6 271,3.57142857 L271,26.4285714 C271,28.4 272.6,30 274.571429,30 L297.428571,30 C299.4,30 301,28.4 301,26.4285714 L301,3.57142857 C301,1.6 299.4,0 297.428571,0 Z M280.285714,11.4285714 L280.285714,25 L276,25 L276,11.4285714 L280.285714,11.4285714 Z M276,7.47857143 C276,6.47857143 276.857143,5.71428571 278.142857,5.71428571 C279.428571,5.71428571 280.235714,6.47857143 280.285714,7.47857143 C280.285714,8.47857143 279.485714,9.28571429 278.142857,9.28571429 C276.857143,9.28571429 276,8.47857143 276,7.47857143 Z M296,25 L291.714286,25 C291.714286,25 291.714286,18.3857143 291.714286,17.8571429 C291.714286,16.4285714 291,15 289.214286,14.9714286 L289.157143,14.9714286 C287.428571,14.9714286 286.714286,16.4428571 286.714286,17.8571429 C286.714286,18.5071429 286.714286,25 286.714286,25 L282.428571,25 L282.428571,11.4285714 L286.714286,11.4285714 L286.714286,13.2571429 C286.714286,13.2571429 288.092857,11.4285714 290.864286,11.4285714 C293.7,11.4285714 296,13.3785714 296,17.3285714 L296,25 Z",
    id: "ic_linkedin"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLinkedin);
export default __webpack_public_path__ + "static/media/ic_linkedin.e9995523b5369cb95606a547fbf58bb0.svg";
export { ForwardRef as ReactComponent };